import type { PersonaFieldProps } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/personaFieldProps';

export const ToneOfVoiceResponseLengthDescriptionField = ({
  field,
  responseLength,
}: Pick<PersonaFieldProps<'pf_tone_of_voice_resp_len'>, 'field' | 'compact'> & {
  responseLength: string;
}) => {
  return field ? (
    <div className={'pl-2.5 border-l border-[#a498ff80]'}>
      {Boolean(responseLength === 'concise') && (
        <p className={'font-medium text-sm text-ebony_opacity_50'}>
          Short and to the point, providing only the key information needed to address the query.
          This option is ideal for quick responses, with links to additional resources for further
          details.
        </p>
      )}
      {Boolean(responseLength === 'standard') && (
        <p className={'font-medium text-sm text-ebony_opacity_50'}>
          Balanced responses that offer clear and informative answers while maintaining brevity.
          They include essential details without overwhelming customers/prospects.
        </p>
      )}
      {Boolean(responseLength === 'comprehensive') && (
        <p className={'font-medium text-sm text-ebony_opacity_50'}>
          Detailed responses that provide in-depth explanations, covering all relevant aspects of
          the query.
        </p>
      )}
    </div>
  ) : null;
};
